import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import './Footer.css';

export const Footer = (props) => {
  const { light } = props;
  let footerText = 'footer__text';
  if (light) {
    footerText += ' footer__text--white';
  }

  const currentYear = moment().format('YYYY');

  return (
    <div className="footer">
      <span className={footerText}>{`Copyright Parity Inc. ${currentYear}`}&nbsp;&nbsp;–&nbsp;&nbsp;</span>
      <Link target="_blank" to="https://www.paritygo.com/privacypolicy" className="footer__link">
        Privacy Policy
      </Link>
      <span className={footerText}>&nbsp;&nbsp;–&nbsp;&nbsp;</span>
      <Link target="_blank" to="https://www.paritygo.com/termsofuse" className="footer__link">
        Terms and Conditions
      </Link>
    </div>
  );
};

Footer.propTypes = { light: PropTypes.bool };
Footer.defaultProps = { light: undefined };
